/* Trichogenix landing – contatori animati dei risultati */
(function () {
  if (window.tgCountersReady) return;
  window.tgCountersReady = true;

  function format(value, decimals) {
    return value.toFixed(decimals).replace('.', ',');
  }

  function animate(el) {
    var target = parseFloat(el.dataset.tgCount);
    var decimals = parseInt(el.dataset.tgDecimals || '0', 10);
    var duration = 1400;
    var start = null;

    function step(now) {
      if (start === null) start = now;
      var progress = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = format(target * eased, decimals);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function init(root) {
    var counters = (root || document).querySelectorAll('[data-tg-count]:not([data-tg-ready])');
    if (!counters.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        animate(entry.target);
      });
    }, { threshold: 0.4 });

    counters.forEach(function (el) {
      if (isNaN(parseFloat(el.dataset.tgCount))) return;
      el.setAttribute('data-tg-ready', '');
      el.textContent = format(0, parseInt(el.dataset.tgDecimals || '0', 10));
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
